import React from 'react';
import backgroundImage from '../assets/Background/Background_3.png';

function Hero({ heroVersion }) {
  return (
    <section className={`hero ${heroVersion === 1 ? 'hero-fill' : 'hero-center'}`} style={{backgroundImage: `url(${backgroundImage})`}}>
      <div className="hero-overlay"></div>
      <div className="container">
        <div className="hero-content">
          <h1 className="hero-title">생각을 전략으로,<br/>변화를 성과로</h1>
          <p className="hero-subtitle">신뢰와 전문성을 갖춘 파트너로 고객과 함께하겠습니다</p>
          <div className="hero-buttons">
            <a href="#services" className="btn btn-primary">사업분야 보기</a>
            <a href="#contact" className="btn btn-secondary">문의하기</a>
          </div>
        </div>
      </div>
      <div className="scroll-indicator">
        <span>Scroll Down</span>
        <div className="scroll-arrow"></div>
      </div>
    </section>
  );
}

export default Hero;
